import type { SetupOptions } from '../types/setup-options';
import config from './config';
import DefaultStore from '../stores/default-store';
import messenger from '../messenger';

function configure(options: Partial<SetupOptions>): void {
  if ('store' in options && !('statePath' in options)) {
    throw new Error(
      messenger.create('"statePath" is required options when custom store is passed')
    );
  }

  config.setup({
    ...options,
    store: options.store || new DefaultStore(),
  });
}

export default configure;
